<!--suppress ALL -->

<template>
	<tr>
		<td class="text-xs-center">
			{{company.name }}
		</td>
		<td>
			<edit-btn @click="onEdit" class="mx-2 my-1"/>
			<remove-btn class="mx-2 my-1"/>
		</td>

	</tr>
</template>

<script>

	import {types} from "src/store/modules/Company.module";
	import RemoveBtn from "src/scaffoldings/RemoveBtn";
	import EditBtn from "src/scaffoldings/EditBtn";
	import RowMixin from "src/mixins/RowMixin";

	export default {
		name: "company-row",
		props: {
			company: {required: true}
		},
		components: {EditBtn, RemoveBtn},
		mixins: [new RowMixin(types, "company")],
		data() {
			return {};
		},
		computed: {},
		methods: {
			doRemove() {
				this.$store.dispatch(types.REMOVE, this.company).then(() => {
				});
			},
			onEdit() {
				this.$emit("edit", this.company);
			}
		}
	};
</script>

<style>


</style>
